import { useState, useEffect } from 'react';
import axios from 'axios';

export default function LiveUsers({ projectId }) {
  const [liveUsers, setLiveUsers] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchLiveUsers = async () => {
    if (!projectId) return;

    try {
      const response = await axios.get(`/analytics/${projectId}/live-users`);
      setLiveUsers(response.data.live_users);
    } catch (error) {
      console.error('Failed to fetch live users:', error);
      setLiveUsers(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLiveUsers();

    // Refresh every 10 seconds
    const interval = setInterval(fetchLiveUsers, 10000);

    return () => clearInterval(interval);
  }, [projectId]);

  if (loading) {
    return (
      <div className="flex items-center gap-2 bg-slate-50 dark:bg-slate-800/50 text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-slate-700 rounded-md px-3 h-11 text-sm font-medium">
        <div className="w-2 h-2 bg-slate-400 dark:bg-slate-500 rounded-full animate-pulse"></div>
        Loading...
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 border border-green-200 dark:border-green-800 rounded-md px-3 h-11 text-sm font-medium">
      <div className="relative flex items-center justify-center">
        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
        <div className="absolute w-2 h-2 bg-green-500 rounded-full animate-ping opacity-75"></div>
      </div>
      {liveUsers} Live
    </div>
  );
}
